import { HIT_VERDICT_LABELS, type CaseHit, type HitVerdict } from './caseDetail';
import { isHitResolved } from './hitResolution';

function effectiveVerdict(hit: CaseHit, overrides: Record<string, HitVerdict>): HitVerdict {
  return overrides[hit.id] ?? hit.verdict;
}

function formatHitBlocks(
  hits: CaseHit[],
  overrides: Record<string, HitVerdict>,
  comments: Record<string, string>,
  includeId: boolean
): string {
  return hits
    .map((hit, index) => {
      const label = includeId ? hit.id : `${index + 1}`;
      const header = `Hit ${label}. ${HIT_VERDICT_LABELS[effectiveVerdict(hit, overrides)]}.`;
      const note = comments[hit.id]?.trim();
      return note ? `${header}\n${note}` : header;
    })
    .join('\n\n');
}

function withCaseSummary(caseSummary: string, body: string): string {
  const note = caseSummary.trim();
  return note ? `Reviewer summary: ${note}\n\n${body}` : body;
}

export function buildInternalEscalationSummary(
  hits: CaseHit[],
  overrides: Record<string, HitVerdict>,
  comments: Record<string, string>,
  caseSummary: string
): string {
  const flagged = hits.filter((hit) => !isHitResolved(hit));
  if (flagged.length === 0) return withCaseSummary(caseSummary, 'No hits to summarise.');
  return withCaseSummary(caseSummary, formatHitBlocks(flagged, overrides, comments, true));
}

export function buildPartnerEscalationSummary(
  hits: CaseHit[],
  overrides: Record<string, HitVerdict>,
  comments: Record<string, string>,
  caseSummary: string
): string {
  const unresolved = hits.filter(
    (hit) => !isHitResolved(hit) && effectiveVerdict(hit, overrides) === 'unknown'
  );
  if (unresolved.length === 0) {
    return withCaseSummary(caseSummary, 'No unresolved hits to summarise.');
  }
  return withCaseSummary(caseSummary, formatHitBlocks(unresolved, overrides, comments, false));
}
